
<template>
  <div>
    <dialog-one-task v-if="!loading_task && one_task.id" :existing_task="one_task" :form_id="one_task.form_id"
      @doneSchedule="handleDoneTask" @close="handleCloseTask" 
    ></dialog-one-task>
    <dialog-loading v-if="loading_task"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api'

export default {
  name: "OneTask",
  components: {
    DialogOneTask: () => import('@/_tasks/components/DialogConfigTask.vue'),
  },
  data() {
    return {
      key: null,
      loading_task: false,
      one_task: {},
    }
  },
  methods: {
    handleDoneTask(e){
      this.$router.push('/tasks')
    },
    handleCloseTask() {
      this.$router.push('/tasks')
    },
    getOneTask(){
      this.loading_task = true
      Api.Task.show(this.$route.params.id).then(r=>r.data).then(r=>{
        this.prepareTask(r)
        // this.one_task = {...r}
        setTimeout(() => {
          this.loading_task = false
        }, 800);
      })
    },
    prepareTask(data){
      if (data){
        let {id, json_attributes,
          schedule_id,
          form_id,
          start_at,
          end_at,
          does_expire,
          employee_id,
          employee_ids,
          duration,
          comment,
          status,
          ...t
        } = data

        let obj = {
          id,
          ...t,
          schedule_id: schedule_id,
          form_id: form_id,

          start_at: start_at,
          start_date_time: start_at,
          start_date: this.$moment(start_at).format('YYYY-MM-DD'),
          start_time: this.$moment(start_at).format('HH:mm'),

          end_at:   end_at,
          end_date_time: end_at,
          end_date: this.$moment(end_at).format('YYYY-MM-DD'),
          end_time: this.$moment(end_at).format('HH:mm'),
          
          kind: does_expire? 'cannot_be_over_due' : 'can_be_overdue',
          employee_ids: [...employee_ids, employee_id],
          employee_id,
          duration: duration,
          description: comment,
          status: status,

        }
        // console.log({obj});
        this.one_task = {...obj}
      }

    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.getOneTask();
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>